/**
 * @requires ./frc.js
 */

frc.modules.careers = function($target, parameters){

	var self = this;

 	self.parameters = jQuery.extend({
 		"coords": null,
 		"brandIDs": null,
 		"locationIDs": null,
 		"categories": null,
 		"regions": null,
 		"sort": "date-newest",
 		"resultsPerPage": 10,
 		"maxDistanceMiles": null
 	}, parameters || {});

	self.data = {
		"listings": null,
		"filteredListings": null,
		"pages": [],
		"currentPageNum": 1
	};

	if((typeof $target=="string")){
		$target = jQuery($target);
	}
	if(!$target.length){
		return;
	}
	self.data.$target = $target;

	self.renderResults = function(extraData){
		self.paginate(self.sort(self.filter(self.data.listings)));

		if(!extraData && (!self.data.filteredListings || !self.data.filteredListings.length)){
			extraData = {
				"messageType": "noresults"
			};
			self.data.pages = null;
		}

		frc.utilities.handlebars.populate("careers-results", jQuery.extend({ "pages": self.data.pages }, extraData || {}), self.data.$target, false);

		if(self.data.filteredListings && self.data.filteredListings.length){
			self.pageTo(1);
		}
		$(self).trigger("resultsrendered", {
			"success": true,
			"numResults": (self.data.filteredListings || []).length
		});
	}

	self.search = function(){
		if(!self.data.listings){
			frc.api.core.getJobs(frcContext.brand.id, function(response){
				if(response.data){
					if(response.data.length){
						// Methodology: do less expensive checks up-front

						var listings = [];
						response.data.forEach(function(brand){
							if(brand.locations){
								brand.locations.forEach(function(location){
									if(location.jobs){
										location.jobs.forEach(function(job){

											// Produce a CSV of subcategories. Note that this assumes the top-level category is the first item and that the job does not fall under multiple top-level categories.
											job.categories_csv = job.categories.slice(1).join(', ');

											// Produce a categories string for filtering purposes
											job.categories_filtering = ';;' + job.categories.join(';;') + ';;';

											// Translate statusIndicationMessage enum
											location.statusIndicationMessageFriendly = frcContext.dictionaries.location_statuses[location.statusIndicationMessage];

											var temp = {
												"brand": brand,
												"location": location,
												"job": job
											};

											delete temp.brand.locations;
											delete temp.location.jobs;
											listings.push(temp);
										});
									}
								});
							}
						});

						// If restricting by criteria not available in the UI, permanently reduce result set
						if(self.parameters.locationIDs&&self.parameters.locationIDs.length){
							listings = self.filter(listings, {
								"locationIDs": self.parameters.locationIDs
							});
						}

						self.data.listings = listings;
						$(self).trigger("dataready");
						self.renderResults();

					} else {
						// No results
						self.renderResults({
							"messageType": "noresults"
						});
					}
				} else {
					// Retrieval failed
					self.renderResults({
						"messageType": "noresults"
					});
				}
			});
		} else {
			self.renderResults();
		}
	}

	self.filter = function(listings, parameters){
		if(!listings){
			return;
		}

		if(!parameters){
			parameters = self.parameters;
		}

		var ret = [];
		listings.forEach(function(listing){
			var qualifies = true;

			// Location IDs
			if(parameters.locationIDs && parameters.locationIDs.indexOf(listing.location.id)===-1){
				qualifies = false;
			}
			// Brand IDs
			if(qualifies && parameters.brandIDs && parameters.brandIDs.indexOf(listing.brand.id)===-1){
				qualifies = false;
			}
			// Regions
			if(qualifies && parameters.regions && parameters.regions.indexOf(listing.location.city + ", " + listing.location.state)===-1){
				qualifies = false;
			}
			// Categories
			if(qualifies && parameters.categories && !frc.utilities.arrayIntersection(parameters.categories, listing.job.categories).length){
				qualifies = false;
			}
			// Coordinates
			if(qualifies && parameters.coords){
				if(listing.location.coordinates) {
					var distanceMiles = frc.utilities.getDistance(parameters.coords[0], parameters.coords[1], listing.location.coordinates[0], listing.location.coordinates[1]);
					if (distanceMiles <= (parameters.maxDistanceMiles||100)) {
						listing.location.distance_miles = distanceMiles;
					} else {
						qualifies = false;
					}
				} else {
					qualifies = false;
				}
			}


			if(qualifies){
				ret.push(listing);
			}

		});

		return ret;
	}

	self.sort = function(listings){
		listings = listings || self.data.filteredListings;

		if(!listings){
			return;
		}

		switch(self.parameters.sort){
			case "distance-nearest":
				listings = listings.sort(function(a, b){
					return a.location.distance_miles - b.location.distance_miles;
				});
			break;
			case "distance-farthest":
				listings = listings.sort(function(a, b){
					return b.location.distance_miles - a.location.distance_miles;
				});
			break;
			case "date-newest":
				listings = listings.sort(function(a, b){
					return b.job.date_modified - a.job.date_modified;
				});
			break;
			case "date-oldest":
				listings = listings.sort(function(a, b){
					return a.job.date_modified - b.job.date_modified;
				});
			break;
		}

		self.data.filteredListings = listings;
		return listings;
	}

	self.paginate = function(){
		if(!self.data.filteredListings || !self.data.filteredListings.length){
			return;
		}
		self.data.pages = [];
		for(var i=0; i<self.data.filteredListings.length; i+=self.parameters.resultsPerPage){
			self.data.pages.push(self.data.filteredListings.slice(i, i + self.parameters.resultsPerPage));
		}
		return self.data.pages;
	}

	self.refreshPaginationLinks = function(){
		var $elt = self.data.$target.find(".pagination");
		$elt.empty();
		if(self.data.pages.length>1){
			self.data.pages.forEach(function(elt, i){
				var pageNum = i + 1;
				var $li = $("<li data-page-num=\"" + pageNum + "\">" + pageNum + "</li>").on("click", function(e){
					e.preventDefault();
					self.pageTo($(this).attr("data-page-num"));
					frc.utilities.anchorScroll('#careers-search');
				}).appendTo($elt);
			});
		}
	}

	self.pageTo = function(pageNum){
		if((typeof pageNum)=="string"){
			pageNum = window.parseFloat(pageNum);
		}

		self.refreshPaginationLinks();

		self.data.currentPageNum = pageNum;

		// Pages
		self.data.$target.find(".page").removeClass("active");
		self.data.$target.find(".page").eq(pageNum-1).addClass("active");

		// Page numbers
		var $pagination = self.data.$target.find(".pagination");
		$pagination.find("li").removeClass("active");
		$pagination.find("li[data-page-num=\"" + pageNum + "\"]").addClass("active");

		self.data.$target.trigger('careers-page-loaded', self.data.currentPageNum);

		// Prev/next
		if(self.data.pages.length>1){
			if(pageNum>1){
				var $li = $("<li data-page-num=\"" + (pageNum-1) + "\" class=\"prev\">&lt; Prev</li>").off("click").on("click", function(e){
					e.preventDefault();
					self.pageTo($(this).attr("data-page-num"));
					frc.utilities.anchorScroll('#careers-search');
				});
				$pagination.prepend($li);
			}
			if(pageNum<self.data.pages.length){
				var $li = $("<li data-page-num=\"" + (pageNum+1) + "\" class=\"next\">Next &gt;</li>").off("click").on("click", function(e){
					e.preventDefault();
					self.pageTo($(this).attr("data-page-num"));
					frc.utilities.anchorScroll('#careers-search');
				});
				$pagination.append($li);
			}
			$pagination.find("li.prev, li.next").off("click").on("click", function(e){
				e.preventDefault();
				self.pageTo($(this).attr("data-page-num"));
			})
		}
	}

};